import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

import { pillWidthClass } from '../dropdownStyles';
import { SubTab } from './data';

interface GenericSubTabProps {
  tab: SubTab;
  vehicleSubTab: string;
  setVehicleSubTab: (subTab: string) => void;
}

export function GenericSubTab({
  tab,
  vehicleSubTab,
  setVehicleSubTab,
}: GenericSubTabProps) {
  if (tab.disabled) {
    return (
      <Tooltip key={tab.value}>
        <TooltipTrigger asChild>
          <span className="flex min-w-0 cursor-default self-stretch">
            <button
              disabled
              className={cn(
                pillWidthClass,
                // overflow-hidden matches every enabled pill sibling — without
                // it, this button's min-content width becomes a shrink floor
                // (flex-shrink can't compress below it), so this pill stayed
                // at its full 184px while siblings shrank together.
                'flex flex-col items-center justify-center overflow-hidden rounded-md border border-[#737373] px-4 text-center text-sm text-telekinesis-neutral-500 opacity-50',
              )}
            >
              <span className="w-full truncate leading-tight">{tab.label}</span>
              {tab.subLabel && (
                <span className="mt-0.5 w-full truncate text-xs leading-tight opacity-80">
                  {tab.subLabel}
                </span>
              )}
            </button>
          </span>
        </TooltipTrigger>
        <TooltipContent side="bottom">Coming soon.</TooltipContent>
      </Tooltip>
    );
  }

  return (
    <button
      key={tab.value}
      onClick={() => setVehicleSubTab(tab.value)}
      className={cn(
        pillWidthClass,
        'self-stretch overflow-hidden rounded-md border px-4 text-sm transition-colors',
        tab.hero
          ? 'flex items-center justify-between gap-3'
          : 'flex flex-col items-center justify-center text-center',
        vehicleSubTab === tab.value
          ? 'border-[#107d40] bg-[#070909] text-[#107d40] hover:border-[#107d40] hover:bg-[#0f3d24]'
          : 'border-[#737373] text-telekinesis-neutral-50 hover:border-[#107d40] hover:bg-[#0f3d24]',
      )}
    >
      {/* justify-center: this column stretches to the pill's full height, so
          without it one-line labels rode ~17px above centre. */}
      <div
        className={cn(
          'flex min-w-0 flex-1 flex-col justify-center',
          tab.hero ? 'items-start' : 'items-center',
        )}
      >
        <span className="w-full truncate leading-tight">{tab.label}</span>
        {tab.subLabel && (
          <span className="mt-0.5 w-full truncate text-xs leading-tight opacity-80">
            {tab.subLabel}
          </span>
        )}
      </div>
      {tab.hero && (
        <div className="flex h-full w-14 flex-shrink-0 items-center justify-center">
          <img
            src={tab.hero}
            alt=""
            aria-hidden="true"
            className="h-full object-contain"
            style={
              tab.heroScale && tab.heroScale !== 1
                ? { transform: `scale(${tab.heroScale})` }
                : undefined
            }
          />
        </div>
      )}
    </button>
  );
}
